import React, { lazy, Suspense } from "react";

const LazyDashboard = lazy(() => import("./DashboardV2"));

const Dashboard = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => {
  return (
    <Suspense fallback={<div></div>}>
      <LazyDashboard />
    </Suspense>
  );
};

export default Dashboard;
